// External imports
import axios from 'axios'
import endPoints from '../../_services/endpoints'
import moment from 'moment'

// Create Redux action types
export const GET_INVENTORY = 'GET_INVENTORY'
export const GET_INVENTORY_SUCCESS = 'GET_INVENTORY_SUCCESS'
export const GET_INVENTORY_FAILURE = 'GET_INVENTORY_FAILURE'

// Create Redux action creators that return an action
export const getInventory = () => ({
    type: GET_INVENTORY,
})

export const getInventorySuccess = (tasks) => ({
    type: GET_INVENTORY_SUCCESS,
    payload: tasks,
})

export const getInventoryFailure = () => ({
    type: GET_INVENTORY_FAILURE,
})

// Fetch inventory
export function fetchInventory(filterStartDate, filterEndDate, setValidated) {
    return async (dispatch) => {
        dispatch(getInventory())

        let startDate = moment(filterStartDate).format("L")
        let endDate = moment(filterEndDate).format("L")
        
        try {
            const loggedInUserData = JSON.parse(localStorage.getItem('userData'));
            if (loggedInUserData) {
                if (loggedInUserData.Token) {
                    axios.defaults.headers['ApplicationSecurityCode'] = loggedInUserData.ApplicationSecurityCode;
                    axios.defaults.headers.common['SECURIT_IDENTITY'] = loggedInUserData.Token;
                }
            }
            const response = await axios.get(`${endPoints.allInventory}?_startDate=${startDate}&_endDate=${endDate}&id=-1`)
            
            // console.log(`${endPoints.allInventory}?startDate=${startDate}&endDate=${endDate}`)
            const data = await response.data
            const resData = data

            if(resData.length > 0){
                resData.map((x) => {
                x.CreatedOn = moment(x.CreatedOn).format('L')
                x.ExpirationDate = moment(x.ExpirationDate).format('L')
                // x.ExpirationDate = moment(x.ExpirationDate, "MM/DD/YYYY").format('L')
                x.InventoryTransactionDate = moment(x.InventoryTransactionDate).format('L')
                x.Cost = x.Cost == null?"$ 0.00":"$" +(x.Cost*1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                x.NetCost = x.NetCost == null?"$ 0.00":"$" +(x.NetCost*1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                return resData
                })
            }
            // setReportData(resData)

            dispatch(getInventorySuccess(resData))
            setValidated(false)
        } catch (error) {
            dispatch(getInventoryFailure())
            setValidated(false)
        }
    }
}

